/*
 * HEIDI 02/08/2026 — panneau « Paramètres » : langue, pays de livraison, devise.
 * Voir snippets/hs-settings-panel.liquid et _docs/parametres-localisation.md.
 *
 * CE SCRIPT NE SERT QU'AU CONFORT. Le panneau est deux `{% form 'localization' %}`
 * portant des `<select>` natifs : sans JavaScript, le bouton d'envoi du `<noscript>`
 * applique le choix. Ici on ajoute l'ouverture, la fermeture, et l'application à la
 * sélection plutôt qu'au bouton.
 *
 * FICHIER SÉPARÉ ET NON UN BLOC `{% javascript %}` : Shopify CONCATÈNE tous les
 * blocs `{% javascript %}` du thème en un seul fichier, où un `TypeError` arrête
 * tout ce qui suit, y compris le code des autres sections.
 */
(function () {
  'use strict';

  var racine = document.querySelector('[data-hs-set]');
  if (!racine) return;

  var panneau = racine.querySelector('[data-hs-set-panel]');
  if (!panneau) return;

  var CLASSE_OUVERT = 'hs-set-show';
  var declencheur = null;

  /* --------------------------------------------------------------------- *
   * L'HÉRITAGE DE `visibility` PREND UNE FRAME À SE PROPAGER.
   * Le panneau est masqué par `visibility: hidden` sur son conteneur — ce qui le
   * retire aussi de l'ordre de tabulation, et c'est voulu. Mais un élément
   * invisible n'est PAS focusable : `.focus()` y est un no-op silencieux. Après
   * avoir retiré la classe, le conteneur se déclare `visible` alors que ses
   * descendants répondent encore `hidden`, et une seule frame ne suffit pas —
   * mesuré au navigateur le 02/08/2026 sur le méga-panneau du menu. D'où cette
   * relance bornée : on réessaie jusqu'à six frames, puis on abandonne.
   * --------------------------------------------------------------------- */
  function focaliser(el, essais) {
    if (!el) return;
    el.focus();
    if (document.activeElement === el) return;
    if (essais <= 0) return;
    requestAnimationFrame(function () { focaliser(el, essais - 1); });
  }

  function estOuvert() {
    return document.body.classList.contains(CLASSE_OUVERT);
  }

  function ouvrir(depuis) {
    if (estOuvert()) return;
    declencheur = depuis || null;
    /* Verrou de défilement à la convention d'Ella : `body.<chose>-show`. */
    document.body.classList.add(CLASSE_OUVERT);
    if (declencheur) declencheur.setAttribute('aria-expanded', 'true');
    focaliser(panneau, 6);
  }

  function fermer(rendreLeFocus) {
    if (!estOuvert()) return;
    document.body.classList.remove(CLASSE_OUVERT);
    if (declencheur) {
      declencheur.setAttribute('aria-expanded', 'false');
      /* Le focus ne revient au déclencheur QUE si la fermeture vient du clavier ou
         de la croix. Après un clic sur le voile, le rendre déplacerait le regard. */
      if (rendreLeFocus) declencheur.focus();
    }
    declencheur = null;
  }

  /* Ouverture — l'écouteur est DÉLÉGUÉ au document. Le tiroir mobile est re-rendu
     par Ella à chaque ouverture et son bouton « Paramètres » y est déplacé par
     `menu.js` : un écouteur posé à l'initialisation serait perdu au premier
     déplacement, et le bouton muet au deuxième essai. */
  document.addEventListener('click', function (e) {
    var ouvreur = e.target.closest ? e.target.closest('[data-hs-set-open]') : null;
    if (ouvreur) {
      e.preventDefault();
      ouvrir(ouvreur);
      return;
    }
    if (!estOuvert()) return;
    var fermeur = e.target.closest ? e.target.closest('[data-hs-set-close]') : null;
    if (fermeur) {
      e.preventDefault();
      /* La croix rend le focus, le voile non — voir `fermer`. */
      fermer(fermeur.classList.contains('hs-set__close'));
    }
  });

  /* Échap ferme, et le focus revient au déclencheur. */
  document.addEventListener('keydown', function (e) {
    if (!estOuvert()) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      fermer(true);
      return;
    }

    /* Piège de focus. `aria-modal="true"` ne suffit pas : il informe les lecteurs
       d'écran, il n'empêche pas la tabulation d'aller derrière le voile. */
    if (e.key !== 'Tab') return;
    var cibles = panneau.querySelectorAll(
      'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
    );
    var visibles = [];
    for (var i = 0; i < cibles.length; i++) {
      var r = cibles[i].getBoundingClientRect();
      if (r.width > 0 || r.height > 0) visibles.push(cibles[i]);
    }
    if (!visibles.length) return;
    var premier = visibles[0];
    var dernier = visibles[visibles.length - 1];
    if (e.shiftKey && (document.activeElement === premier || document.activeElement === panneau)) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault();
      premier.focus();
    }
  });

  /* --------------------------------------------------------------------- *
   * APPLIQUER À LA SÉLECTION.
   * `requestSubmit` et non `submit` : `submit()` court-circuite la validation et
   * l'événement `submit`, que Shopify ou une app pourraient écouter. Repli sur
   * `submit()` là où `requestSubmit` manque.
   * Garde sur la valeur : un `change` qui ne change rien — reclic sur l'option
   * déjà sélectionnée — ne doit pas recharger la page.
   * --------------------------------------------------------------------- */
  var selects = racine.querySelectorAll('[data-hs-set-auto]');
  for (var s = 0; s < selects.length; s++) {
    (function (sel) {
      var initial = sel.value;
      sel.addEventListener('change', function () {
        if (sel.value === initial) return;
        var f = sel.form;
        if (!f) return;
        sel.setAttribute('disabled', 'disabled');
        /* Le champ désactivé ne serait pas envoyé : on repose la paire à la main. */
        var relais = document.createElement('input');
        relais.type = 'hidden';
        relais.name = sel.name;
        relais.value = sel.value;
        f.appendChild(relais);
        if (typeof f.requestSubmit === 'function') { f.requestSubmit(); } else { f.submit(); }
      });
    })(selects[s]);
  }
})();
